import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoMessenger = () => {
  return (
    <g>
      <path d="m8 .3147a7.3851 7.3851 0 0 0 -7.5824 7.1707 7.0108 7.0108 0 0 0 2.7448 5.5216v2.6783l2.5813-1.3521a7.9818 7.9818 0 0 0 2.2563.3228 7.3851 7.3851 0 0 0 7.5824-7.1707 7.3851 7.3851 0 0 0 -7.5824-7.1706zm.7891 9.6753-1.99-2.1272-3.8426 2.0585 4.1171-4.3913 1.99 1.99 3.8426-2.0586z" />
    </g>
  );
};

export default withIcon(IconLogoMessenger);
